import {
	AcademySearchRequest,
	academySearchAdapter,
	academyFiltersAdapter,
	academyEntryDetailAdapter,
} from 'application/adapters/academy/academyAdapter';

export const getAcademySearchResults = (payload: AcademySearchRequest, host, locale): Promise<any> => {
	return academySearchAdapter(payload, host, locale);
};

export const getAcademyFilters = (host, locale): Promise<any> => {
	return academyFiltersAdapter(host, locale);
};

export const getAcademyEntryDetailById = (id: string, host: string): Promise<any> => {
	return academyEntryDetailAdapter(id, host);
};
